import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=f80b8d60&scoped=true"
import script from "./ListProduct.vue?vue&type=script&lang=ts"
export * from "./ListProduct.vue?vue&type=script&lang=ts"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=f80b8d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80b8d60",
  null
  
)

export default component.exports